export default __webpack_public_path__ + "static/philosophyAnsMission-9661546394270b0d6f20b8194ce8912e.svg";